import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faChartSimple } from '@fortawesome/pro-light-svg-icons/faChartSimple';
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine';
import { faTags } from '@fortawesome/pro-light-svg-icons/faTags';
import { SerializedPublicAccountTrackerType } from 'fym-common/src/db/serializersTypes';

export interface TrackerProviderMark {
  /** Brand name. The same word in every language, so it is not translated. */
  name: string;
  /** The square behind the glyph, in the provider's own colour. */
  color: string;
  icon: IconDefinition;
}

const googleAnalyticsMark: TrackerProviderMark = {
  name: 'Google Analytics',
  color: '#e8710a',
  icon: faChartSimple,
};

const marks: Record<SerializedPublicAccountTrackerType, TrackerProviderMark> = {
  [SerializedPublicAccountTrackerType.facebookPixel]: {
    name: 'Facebook Pixel',
    color: '#0866ff',
    icon: faFacebookF,
  },
  [SerializedPublicAccountTrackerType.googleAnalytics]: googleAnalyticsMark,
  [SerializedPublicAccountTrackerType.googleAnalyticsLegacy]: googleAnalyticsMark,
  [SerializedPublicAccountTrackerType.googleGlobalSite]: googleAnalyticsMark,
  [SerializedPublicAccountTrackerType.googleTagManager]: {
    name: 'Google Tag Manager',
    color: '#246fdb',
    icon: faTags,
  },
  [SerializedPublicAccountTrackerType.plausible]: {
    name: 'Plausible',
    color: '#5850ec',
    icon: faChartLine,
  },
};

export function trackerProviderMark(type: SerializedPublicAccountTrackerType): TrackerProviderMark | undefined {
  return marks[type];
}

/** The three the page advertises. Google Tag Manager and the older Google tags still work, they are just not sold here. */
export const supportedTrackerTypes: SerializedPublicAccountTrackerType[] = [
  SerializedPublicAccountTrackerType.facebookPixel,
  SerializedPublicAccountTrackerType.googleAnalytics,
  SerializedPublicAccountTrackerType.plausible,
];

/**
 * Which advertised chip a detected type lights up. The three Google tag
 * flavours all mean "Google Analytics" to the artist.
 */
export function chipTypeFor(type: SerializedPublicAccountTrackerType): SerializedPublicAccountTrackerType {
  switch (type) {
    case SerializedPublicAccountTrackerType.googleAnalyticsLegacy:
    case SerializedPublicAccountTrackerType.googleGlobalSite:
    case SerializedPublicAccountTrackerType.googleAnalytics:
      return SerializedPublicAccountTrackerType.googleAnalytics;
    case SerializedPublicAccountTrackerType.facebookPixel:
      return SerializedPublicAccountTrackerType.facebookPixel;
    case SerializedPublicAccountTrackerType.googleTagManager:
      return SerializedPublicAccountTrackerType.googleTagManager;
    case SerializedPublicAccountTrackerType.plausible:
      return SerializedPublicAccountTrackerType.plausible;
    default:
      return type;
  }
}
